import type { FaireProductEntity } from "../../entity_types/product";

export const p_7hqtaekph6: FaireProductEntity = {
  token: "p_7hqtaekph6",
  type: "product",
  name: "Favorite Sister Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/b06659b267480f2ac445dcd689992976eec556f823a51382b1492b8d032f6805.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a4a73a6b285ce2959c5bed911d560a45145260bb6a8870c5cc1f17dd6de0ca3e.jpeg",
    "https://cdn.faire.com/fastly/1b74b3089b1f5550c800352078ea140ba57cd098d29072549e5b85f4b004bb10.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/a2d2a4bcd8997834a215eac045ec706ae0ab6008a7650a62b391304afa52eb5d.jpeg",
    "https://cdn.faire.com/fastly/f85172b0150330afd6009d0bf8f1e516b4ab84a845ca6cf46c46f56208020fa7.jpeg",
    "https://cdn.faire.com/fastly/285becc816679354c8fe58ed387049c208701a716ef0ca3bbefabbd38be2e12a.jpeg",
    "https://cdn.faire.com/fastly/d2080a286c6a1ea2c3c4e607768540fc030fca53a266f8cb4f4f0b55419f91bc.jpeg"
  ],
  priceDollars: 6.75,
  description: "For the sister with superior taste (in socks and everything else).\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:28:10.722Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
